import { getRequest, postRequest, getcontractIdNumber, deleteRequest, downloadRequest } from './api'
import { API_URL_INVENTORY } from '../constants/index'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `inventory/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`inventory/edit/${id}`)
}

export async function mlfb(id, classID) {
  const contractId = getcontractIdNumber()
  return getRequest(`inventory/get-product-mlfb2/${contractId}/${id}/${classID || 0}`)
}

export async function save(values) {
  return postRequest(`inventory/save`, values)
}

export function remove(id) {
  return deleteRequest(`${API_URL_INVENTORY}inventory/${id}`)
}

export async function list2(
  size,
  index,
  searchTerm,
  orderBy,
  inventoryNumber,
  deviceInfo,
  appropriation,
  className,
  areaName,
  location,
  street,
  model,
  serialNumber,
  mlfbNumber,
  emhBarcode,
  status,
  costTypeCode,
) {
  const contractID = getcontractIdNumber()
  const url = `inventory/get-list2/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm ||
    '%20'}/${orderBy || '%20'}/${contractID}/${inventoryNumber || '%20'}/${deviceInfo ||
    '%20'}/${appropriation || '%20'}/${className || '%20'}/${areaName || '0'}/${location ||
    '0'}/${street || '%20'}/${model || '%20'}/${serialNumber || '%20'}/${mlfbNumber ||
    '%20'}/${emhBarcode || '%20'}/${status || '%20'}/${costTypeCode || '%20'}`
  return getRequest(url)
}

export async function importData(values) {
  console.log('importData', values)
  const headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  }
  return postRequest(`inventory/import`, values, headers)
}

export async function exportData() {
  const token = localStorage.getItem('token')
  const contractID = getcontractIdNumber()

  return downloadRequest(`inventory/export?token=${token}&contractID=${contractID}`)
}

// PROTEC-950: the import template is generated like the export (dropdowns, colors,
// mandatory marks) - sheets Main Inventory + Inventory + column descriptions.
export async function downloadImportTemplate() {
  const token = localStorage.getItem('token')
  const contractID = getcontractIdNumber()

  return downloadRequest(`inventory/export?token=${token}&contractID=${contractID}&template=true`)
}

export async function bulkUpdateNextPmDate(values) {
  return postRequest(`inventory/bulkupdatenextpmdate`, values)
}
